import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-all-clients',
  templateUrl: './all-clients.component.html',
  styleUrls: ['./all-clients.component.css'],

})
export class AllClientsComponent implements OnInit {
  clientLst: any;
  prefix: string;
  selectedRows: number[];
  selectionChangedBySelectbox: boolean;
  checkBoxesMode: string;
  allMode: string;
  selectedItemKeys: any;
  status = [];
  temp = [];
  userDtls: any;
  constructor(private http: HttpClient,
    private usrService: UserService,
    private toaster: ToastrService,
    public router: Router) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'onClick';
    // this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    if (!localStorage.getItem('userDetails')) {
      // alert("User Already Loged out , Please Login Again");
      this.router.navigate(["login-admin"]);
    } else {
      this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    }
  }

  ngOnInit() {
    this.usrService.allClients().subscribe((res) => {
      this.clientLst = res['data'];
    })
  }

  selectionChanged(data: any) {
    this.selectedItemKeys = data.selectedRowKeys;
  }

  changeStatus(sts) {
    this.status = [];
    this.temp = [];
    if (this.selectedItemKeys && this.selectedItemKeys.length > 0) {
      this.selectedItemKeys.forEach(element => {
        console.log(element);
        if (sts == 2) {
          this.status.push(element.user_id);
        } else if (sts != element.status) {
          this.status.push(element.user_id);
        } else if (sts == element.status) {
          this.temp.push(element.user_id);
        }
      });
    } else {
      this.toaster.success("please select atleast one category to perform action");
    }


    if (this.status.length > 0) {
      let mngeCtgry = {
        id: this.status,
        flag: sts,
        admin_id: this.userDtls.userId
      }
      console.log(mngeCtgry);
      this.usrService.updateClientStatus(mngeCtgry).subscribe((udtRes) => {
        if (udtRes['code'] == 200) {
          this.toaster.success(this.status.length + ' ' + udtRes['message']);
          this.ngOnInit();
        }
      })
    } else if (this.temp.length > 0) {
      this.toaster.success(this.temp.length + ' Un Action Records selected.');
    }
  }
}

